import React, { useState, useEffect } from "react";
import { Button, Popover } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getRequestsToApprove, logout } from "../../actions/index";
import { toggleSidebar } from "../../actions";
import { CernToolbar } from "@authzsvc/common-react-components";
import HeaderDropdownItems from "./HeaderDropdownItems";

const HeaderMenuItems = ({
  authenticated,
  toggleSidebar,
  getRequestsToApprove,
  keycloak,
  userToken,
}) => {
  const [firstRequests, setFirstRequests] = useState(false);

  const menuItems = HeaderDropdownItems();

  useEffect(() => {
    if (authenticated && !firstRequests) {
      getRequestsToApprove();
      setFirstRequests(true);
    }
  }, [authenticated, firstRequests, getRequestsToApprove]);
  console.log(process.env.REACT_APP_ENVIRONMENT);

  return (
    <CernToolbar
      authenticated={authenticated}
      keycloak={keycloak}
      userToken={Array.isArray(userToken) ? userToken : []}
      extraLogoutFct={logout}
      menuItems={menuItems || []}
      environment={process.env.REACT_APP_ENVIRONMENT}
    >
      <div
        className="hamburger-menu"
        style={{ display: "inline-block", marginRight: 12 }}
      >
        <Popover content="Expand Help" mouseEnterDelay={1}>
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 16, color: "#fff" }} />}
            onClick={toggleSidebar}
          />
        </Popover>
      </div>
    </CernToolbar>
  );
};

const requestInFinalState = (request) => {
  return request.status !== "Pending";
};

export default connect(
  (state) => ({
    authenticated: state.keycloak.authenticated,
    keycloak: state.keycloak.instance,
    userToken: state.keycloak.userToken,
    pendingRequests: state.applicationRequests.toApprove.filter(
      (r) => requestInFinalState(r) === false,
    ).length,
  }),
  { getRequestsToApprove, logout, toggleSidebar },
)(HeaderMenuItems);

HeaderMenuItems.propTypes = {
  authenticated: PropTypes.bool,
  toggleSidebar: PropTypes.func,
  getRequestsToApprove: PropTypes.func,
  keycloak: PropTypes.object,
  userToken: PropTypes.object,
};
